let drapElem = null; // 当前拖拽的元素数据
let componentContext = null; // 当前组件上下文

// 拖拽事件列表
const dragEventList = {
    dragstart(event, item) {
        event.dataTransfer.setData('val', item.value);
        event.dataTransfer.effectAllowed = 'all';
        drapElem = item;
    },
    dragend(event, item) {
        drapElem = null;
    },
    dragenter(event, item) {
        if (drapElem.value !== item.value) {
            event.target.style.background = '#f1f1f1';
        }
    },
    dragover(event, item) {
        event.preventDefault();
    },
    dragleave(event, item) {
        if (drapElem.value !== item.value) {
            event.target.style.background = 'transparent';
        }
    },
    drop(event, item) {
        if (drapElem.value !== item.value) {
            event.target.style.background = 'transparent';
            const dragIndex = componentContext.printList.findIndex(v => v.value === drapElem.value);
            const targetIndex = componentContext.printList.findIndex(v => v.value === item.value);
            if (drapElem.expose && !item.expose) {
                delete drapElem.expose;
                item.expose = true;
            } else if (drapElem.expose && item.expose) {
                drapElem.expose = true;
                item.expose = true;
            } else if (!drapElem.expose && item.expose) {
                drapElem.expose = true;
                delete item.expose;
            }
            componentContext.printList.splice(targetIndex, 1, drapElem);
            componentContext.printList.splice(dragIndex, 1, item);
            drapElem = null;
        }
    },
    action(event, item, eventName, ctx) {
        componentContext = ctx;
        dragEventList[eventName](event, item);
    }
};

export default dragEventList;
